/* Rebuy supplies products and attribution; native scrolling keeps WT's breakpoints. */
(function () {
  if (window.WestonPdpRebuy) return;
  window.WestonPdpRebuy = {
    update(list) {
      const carousel = list.closest('.wt-pdp-rebuy__carousel');
      carousel.querySelector('.wt-pdp-rebuy__prev').disabled = list.scrollLeft < 1;
      carousel.querySelector('.wt-pdp-rebuy__next').disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 1;
    },
    move(event, direction) {
      const list = event.currentTarget.closest('.wt-pdp-rebuy__carousel').querySelector('.wt-pdp-rebuy__list');
      const card = list.firstElementChild;
      if (!card) return;
      const width = card.getBoundingClientRect().width;
      const count = Math.max(1, Math.floor((list.clientWidth + 1) / width));
      list.scrollBy({left: direction * width * count, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    },
    galleryImage(product) {
      const images = Array.isArray(product?.images) ? product.images : [];
      return images.length > 1 ? images[1] : (images[0] || product?.image || null);
    },
    cardImage(product, sizeImage) {
      const image = this.galleryImage(product);
      const src = typeof image === 'string' ? image : image?.src;
      if (!src) return '';
      if (typeof sizeImage === 'function') return sizeImage(src, '600x600');
      return src.replace(/(\.(jpe?g|png|gif|webp))(\?.*)?$/i, '_600x600$1$3');
    },
    cardImageAlt(product) {
      const image = this.galleryImage(product);
      if (image && typeof image === 'object' && image.alt) return image.alt;
      return product?.title || '';
    },
    priceRange(product, variantPrice, formatMoney) {
      const prices = product.variants.map((variant) => Math.round(Number(variantPrice(product, variant)) * 100)).filter(Number.isFinite);
      if (!prices.length) return '';
      const minimum = Math.min(...prices);
      const maximum = Math.max(...prices);
      const money = (price) => formatMoney(price).replace(/\.00(?=\D|$)/g, '');
      return minimum === maximum ? money(minimum) : money(minimum) + ' - ' + money(maximum);
    },
  };
  function configure(event) {
    const widget = event.detail?.widget;
    if (String(widget?.id) !== '259540') return;
    // This instance uses the theme's scroll carousel instead of Rebuy's fixed breakpoints.
    Object.values(widget.data?.settings?.layout || {}).forEach((layout) => {
      if (layout && typeof layout === 'object') layout.carousel = false;
    });
  }
  function mount() {
    document.querySelectorAll('.wt-pdp-rebuy__list').forEach(window.WestonPdpRebuy.update);
  }
  document.addEventListener('rebuy.init', configure);
  document.addEventListener('rebuy.beforeReady', configure);
  document.addEventListener('rebuy.ready', () => requestAnimationFrame(mount));
  document.addEventListener('rebuy.productsChange', () => requestAnimationFrame(mount));
  document.addEventListener('shopify:section:unload', (event) => {
    if (!event.target.querySelector('.wt-pdp-rebuy')) return;
    window.Rebuy?.widgets?.find((widget) => String(widget.id) === '259540')?.destroy?.();
  });
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.wt-pdp-rebuy')) window.Rebuy?.init?.();
  });
  window.addEventListener('resize', mount, {passive: true});
  mount();
})();
